import React, { useState, useEffect } from 'react';
import CloudUploadRoundedIcon from '@mui/icons-material/CloudUploadRounded';
import { FormHelperText, IconButton } from '@mui/material';
import { pdfjs } from 'react-pdf';
import axios from 'axios';
import { FILE_TYPE_NAMES } from '../../config/constant';
import { useQuantityContext } from '../QuantityContext';
import { getReadableFileTypes } from './ValidationFunctions';

// Set worker URL for PDF.js
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const FileDragUploadWithContext = ({
  label,
  contextKey,
  accept,
  maxSize,
  inputId,
  context,
  updateContext,
   required = false,
  error = false,
  helperText = ""
}) => {
  const [zoom, setZoom] = useState(95);
  const [numPages, setNumPages] = useState(null);
  const [previewImage, setPreviewImage] = useState('');

  const maxSizeInBytes = maxSize * 1024 * 1024;

 

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    // validateAndUploadFile(file);
    if (file) {
      validateAndUploadFile(file);

    } else { }
    event.target.value = null;
  };

  const { handleFailure, handleInfo } = useQuantityContext();

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const file = event.dataTransfer.files[0];
    if (file) {
      validateAndUploadFile(file);
    } else { }
  };

  const validateAndUploadFile = async (file) => {
    if (file && accept.includes(file.type)) {


      if (file.size <= maxSizeInBytes) {
        try {
          // const formData = new FormData();


          // formData.append('file', file);

          // const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url`, formData, {
          //   headers: {
          //     'Content-Type': 'multipart/form-data',
          //   },
          // });

          // const { url } = response.data;
          const objectUrl = URL.createObjectURL(file);

          updateContext({
            [contextKey]: {
              name: file.name || 'file',
              type: file.type,
              data: objectUrl,
              size: formatFileSize(file.size),

            },
          });
          // console.log("UpdateContext in the Image Upload component", updateContext);


          if (file.type === 'application/pdf') {
            // Convert PDF to ArrayBuffer for preview generation
            const reader = new FileReader();
            reader.onloadend = () => {
              const pdfArrayBuffer = reader.result;
              generatePDFPreview(pdfArrayBuffer); // Generate preview from freshly uploaded PDF
            };
            reader.readAsArrayBuffer(file);
          } else {
            // Generate image preview
            const reader = new FileReader();
            reader.onloadend = () => {
              setPreviewImage(reader.result);
            };
            reader.readAsDataURL(file);
          }
        } catch (error) {
          console.error('Error uploading file:', error);
          // alert('Error uploading file. Please try again.');
          handleFailure("Error uploading file. Please try again.");
        }
      } else {
        // alert(`File size must be ${maxSize} or less.`);
        handleInfo(`File size must be ${maxSize} or less.`);
      }
    }

    else {
      // Map MIME types to their short names
      const shortNames = accept.map(type => FILE_TYPE_NAMES[type] || type);

      // alert(`Invalid file type. Only ${shortNames.join(", ")} are allowed.`);
      handleInfo(`Invalid file type. Only ${shortNames.join(", ")} are allowed.`);
    }
  };




  // Generate a PDF preview from either uploaded or blob URL
  const generatePDFPreview = (pdfData) => {
    pdfjs.getDocument({ data: pdfData }).promise.then((pdf) => {
      pdf.getPage(1).then((page) => {
        const viewport = page.getViewport({ scale: 1 });
        const canvas = document.createElement('canvas');
        const canvasContext = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        page.render({ canvasContext, viewport }).promise.then(() => {
          setPreviewImage(canvas.toDataURL('image/jpeg')); // Set preview image for PDF
        });
      });
    });
  };

  // Generate PDF preview when the component is mounted (for fetched blob URL)
  useEffect(() => {
    if (context && context[contextKey] && context[contextKey].data && context[contextKey].type === 'application/pdf') {
      // Fetch blob from the blob URL to generate PDF preview
      fetch(context[contextKey].data)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const pdfArrayBuffer = reader.result;
            generatePDFPreview(pdfArrayBuffer); // Generate preview from blob URL
          };
          reader.readAsArrayBuffer(blob); // Convert blob to ArrayBuffer for pdf.js
        })
        .catch((error) => {
          console.error('Error fetching blob for PDF preview:', error);
        });
    }
  }, [context, contextKey]);

  const handleRemoveFile = () => {
    updateContext({ [contextKey]: { name: '', type: '', url: '', zoom: 100 } });
    setPreviewImage('');
  };

  const formatFileSize = (size) => {
    // console.log("PROFILE IMAGE in UPLOAD CONTEXT", size);
    if (size >= 1000000) {

      return `${(size / 1000000).toFixed(1)} Mb`;
    } else {
      return `${(size / 1000).toFixed(0)} Kb`;
    }
  };

  return (
    <div className='add-logo-container text-left'
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}>
      <p className='mt-0'>{label}</p>
      <div className="file-upload-container p-2" onClick={() => document.getElementById(inputId).click()} style={{ overflow: "hidden" }}>
        {context && context[contextKey] && context[contextKey]?.data ? (
          <>
            {context[contextKey].type === 'application/pdf' && previewImage ? (
              // Show the preview for PDF files
              <img src={previewImage} alt='PDF Preview' style={{ height: `${zoom}%`, width: `${zoom}%`, transition: 'width 0.2s', objectFit: "contain" }} />
            ) : (
              // Show the image preview if it's an image
              <img src={context[contextKey].data} alt='Uploaded File' style={{ height: `${zoom}%`, width: `${zoom}%`, transition: 'width 0.2s', objectFit: "contain" }} />
            )}
          </>
        ) : (
          <>
            <IconButton color="inherit">
              <CloudUploadRoundedIcon style={{ color: 'rgb(0, 0, 0, 0.54)' }} />
            </IconButton>
            <div>Drag file here or <strong className='color-blue'>Upload File</strong></div>
            <div className='tertiary-text'>{maxSize} Mb Max File Size</div>
            <div className='tertiary-text' style={{ fontSize: "12px" }}>{`(${getReadableFileTypes(accept).join(" | ")})`}</div>
          </>
        )}
       
       <input id={inputId} type="file" accept={accept.join(",")} style={{ display: 'none' }} onChange={handleFileChange} required />
       <div className={error ? "error-field" : ""}>
      {/* Your existing upload component code */}
      {error && <FormHelperText error>{helperText}</FormHelperText>}
    </div>
      </div>
    </div>
  );
};

export default FileDragUploadWithContext;
